<template>
  <div ref="mapDialog">
    <Cloud :showDialog.sync="showDialog"></Cloud>
    <div class="fullScreen">
      <img @click="showDialog = true" src="@/assets/img/overview/photo.png">
    </div>
  </div>
</template>

<script>
import Cloud from './Cloud'
export default {
  name: 'CloudMap',
  components: {
    Cloud
  },
  data () {
    return {
      showDialog: false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  destroyed () {
  },
  methods: {
  }
}
</script>
<style scoped lang='scss'>
.fullScreen{
  position: absolute;
  bottom: 20px;
  right: 350px;
  cursor: pointer;
  z-index: 100;

  img {
    width: 80px;
    height: 80px;
  }
}
</style>
